import axiosInstance from './axiosInstance';

export const getEmailPackProducts = () =>
	axiosInstance.get('/email-packs/products');

export const getEmailPackSummary = (companyId) =>
	axiosInstance.get(`/email-packs/summary/${companyId}`);

export const createEmailPackCheckout = ({ companyId, packKey, successPath }) =>
	axiosInstance.post('/email-packs/checkout', {
		companyId,
		packKey,
		successPath,
	});

export const createEmailPackPaymentIntent = ({ companyId, packKey }) =>
	axiosInstance.post('/email-packs/payment-intent', { companyId, packKey });

export const confirmEmailPackPurchase = ({
	companyId,
	packKey,
	paymentIntentId,
	subscriptionId,
	setupIntentId,
}) =>
	axiosInstance.post('/email-packs/confirm', {
		companyId,
		packKey,
		paymentIntentId,
		subscriptionId,
		setupIntentId,
	});

export const syncEmailPackLimits = (companyId) =>
	axiosInstance.post(`/email-packs/sync/${companyId}`);
